import { Injectable } from "@angular/core";
import { CurrentSupplier, ISupplierDTO, IUpdateFromCompanyInfoPage, IUpdateProp65Info } from "@app/_core/account/current-supplier.interface";
import { ReplaySubject } from "rxjs";
import { ModelsMapper } from "../helpers/models.mapper";
import { CurrentUser } from "./current-user.interface";
import { UserRole } from "./user-role";

@Injectable({
	providedIn: "root",
})
export class CurrentUserService {
	private currentUser: CurrentUser;
	private currentSupplier: CurrentSupplier;
	private currentUserSubject = new ReplaySubject<CurrentUser>();
	private currentSupplierSubject = new ReplaySubject<CurrentSupplier>();
	currentUser$ = this.currentUserSubject.asObservable();
	currentSupplier$ = this.currentSupplierSubject.asObservable();
	constructor() {}

	getCurrentUser(): CurrentUser {
		return this.currentUser;
	}

	setCurrentUser(user: CurrentUser): void {
		this.currentUser = user;
		this.currentUserSubject.next(this.currentUser);
	}

	resetCurrentUser(): void {
		delete this.currentUser;
		delete this.currentSupplier;
		this.currentUserSubject.next(this.currentUser);
		this.currentSupplierSubject.next(this.currentSupplier);
	}

	isNonAdmin(): boolean {
		return this.currentUser && (this.currentUser.role === UserRole.PRIMARY || this.currentUser.role === UserRole.PROP65);
	}

	isAdmin(): boolean {
		return this.currentUser && (this.currentUser.role === UserRole.ADMIN || this.currentUser.role === UserRole.SUPER_ADMIN);
	}

	isSuperAdmin(): boolean {
		return this.currentUser && this.currentUser.role === UserRole.SUPER_ADMIN;
	}

	isJustAdmin(): boolean {
		return this.currentUser && this.currentUser.role === UserRole.ADMIN;
	}

	isProp65(): boolean {
		return this.currentUser && this.currentUser.role === UserRole.PROP65;
	}

	getSupplier(): CurrentSupplier {
		return this.currentSupplier;
	}

	getSupplierAsInterface(): ISupplierDTO {
		return ModelsMapper.mapSupplierClassToInterface(this.currentSupplier);
	}

	setSupplier(supplier: ISupplierDTO): void {
		this.currentSupplier = new CurrentSupplier(supplier);
		this.currentSupplierSubject.next(this.currentSupplier);
	}

	updateCompanyInfo(updateData: IUpdateFromCompanyInfoPage): void {
		this.currentSupplier.updateCompanyInfo(updateData);
		this.currentSupplierSubject.next(this.currentSupplier);
	}

	markProfileCompleted(): void {
		this.currentSupplier.markProfileCompleted();
		this.currentSupplierSubject.next(this.currentSupplier);
	}

	updateProp65Info(updateData: IUpdateProp65Info) {
		this.currentSupplier.updateProp65Info(updateData);
		this.currentSupplierSubject.next(this.currentSupplier);
	}

	isInfoComplete(): boolean {
		if (this.currentSupplier?.supplierName && this.currentSupplier?.websiteURL) {
			return true;
		}
		return false;
	}

	get isPrimaryUser(): boolean {
		return this.currentUser && this.currentUser.role === UserRole.PRIMARY;
	}

	get isCustomer(): boolean {
		return this.currentUser && this.currentUser.role === UserRole.CUSTOMER;
	}
}
